import React, { Fragment } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { Pagination } from 'react-bootstrap';

const TablePagination = ({total, index, limit, indexChange}) => {
  let start = 1
  let end = 5
  let last = 5
  last = Math.ceil(total/limit) || 1;
  let indexList = []
  if (last <= 5 ){
    start = 1
    end = last
  } else {
    if (index > 3) {
      start = index - 2
      end = index + 2
    }
    if (end > last) {
      start = last - 4
      end = last
    }
  }
  for (let i = start; i <= end; i++) {
    indexList.push(i)
  }

  return (
    <Fragment>
      <Pagination>
        <div className='form-pagination'>
          <Pagination.Item onClick={() => indexChange(index-1 >= start ? index-1 : start)}>
            <FontAwesomeIcon icon={faAngleLeft}/>
          </Pagination.Item>
          {indexList.map(item => (
            <Pagination.Item
              key={`pagination-key-index${item}`}
              active={index === item}
              onClick={() => indexChange(item)}
            >
            {item}
            </Pagination.Item>
          ))}
          <Pagination.Item onClick={() => indexChange(index+1 <= last ? index+1 : end)}>
            <FontAwesomeIcon icon={faAngleRight}/>
          </Pagination.Item>
        </div>
      </Pagination>
    </Fragment>
  );
}

export default TablePagination;
